import React, { useContext, useState, useEffect } from 'react'
import { Drawer, Portal } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { useMobile } from 'src/hooks/Mobile'
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined'
import { Body2 } from '@flatsy/core/MaterialUi/Typo'
import { useStyles } from './Style'
import { FileContext } from '../Context'
import PreUploader from '../MainContainer/FilesOverview/PreUploader'

const MobileAddFileButton: React.FC = (): React.ReactElement => {
  const {
    upload: { openModal },
  } = useContext(FileContext)
  const mobile = useMobile()
  const classes = useStyles()
  const navigationButton = document.querySelector('#add-file-navigation-button')
  const [open, setOpen] = useState(false)

  const onClickOpen = () => {
    setOpen(true)
  }
  const onClickClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (openModal) {
      setOpen(false)
    }
  }, [openModal])

  if (!mobile) {
    return <></>
  }

  return (
    <>
      <Portal container={navigationButton}>
        <div className={classes.wrapper}>
          <button className={classes.container} onClick={onClickOpen} type="button">
            <AddIcon className={classes.icon} />
          </button>
        </div>
      </Portal>
      <Drawer anchor="bottom" open={open} onClose={onClickClose} className={classes.drawer}>
        <div className={classes.info}>
          <EmojiObjectsOutlinedIcon className={classes.infoIcon} />
          <Body2 className={classes.infoContent}>
            Pour une meilleure expérience, nous recommandons d’utiliser un ordinateur pour envoyer
            vos pièces
          </Body2>
        </div>
        <PreUploader />
      </Drawer>
    </>
  )
}

export default MobileAddFileButton
